import { Grid } from '@material-ui/core';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import { CloudOutlined, LocalShippingOutlined } from '@material-ui/icons';
import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import TopPage from 'v2/components/Shared/TopPage';
import { EProductType } from 'v2/interfaces/product';
import eduzzAccountsService from 'v2/services/eduzzAccount';

import { ButtonRedirect } from './ButtonRedirect';

import type { DispatchProp } from 'react-redux';

function DesignServicesIcon() {
  return (
    <svg focusable='false' aria-hidden='true' viewBox='0 0 24 24' data-testid='DesignServicesIcon' style={{ width: 35 }}>
      <path d='m16.24 11.51 1.57-1.57-3.75-3.75-1.57 1.57-4.14-4.13c-.78-.78-2.05-.78-2.83 0l-1.9 1.9c-.78.78-.78 2.05 0 2.83l4.13 4.13L3 17.25V21h3.75l4.76-4.76 4.13 4.13c.95.95 2.23.6 2.83 0l1.9-1.9c.78-.78.78-2.05 0-2.83l-4.13-4.13zm-7.06-.44L5.04 6.94l1.89-1.9L8.2 6.31 7.02 7.5l1.41 1.41 1.19-1.19 1.45 1.45-1.89 1.9zm7.88 7.89-4.13-4.13 1.9-1.9 1.45 1.45-1.19 1.19 1.41 1.41 1.19-1.19 1.27 1.27-1.9 1.9zm3.65-11.92c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.47-.47-1.12-.29-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z'></path>
    </svg>
  );
}

function DesignSubscriptionIcon() {
  return (
    <svg focusable='false' aria-hidden='true' viewBox='0 0 24 24' data-testid='DesignServicesIcon' style={{ width: 33 }}>
      <path d='M15.6352 1.01007C15.9403 0.704976 16.435 0.704976 16.7401 1.01007L22.9901 7.26007C23.2952 7.56517 23.2952 8.05983 22.9901 8.36493L20.0181 11.3369L18.7237 16.5147C18.5232 17.3167 17.9151 17.9537 17.1234 18.1912L0.959961 23.0402L5.80898 6.87681C6.0465 6.08507 6.68352 5.47699 7.48544 5.27651L12.6633 3.98206L15.6352 1.01007ZM12.823 5.55271L7.86441 6.79236C7.5971 6.85919 7.38476 7.06188 7.30558 7.32579L3.29039 20.7098L16.6744 16.6946C16.9383 16.6154 17.141 16.4031 17.2078 16.1358L18.4475 11.1771L12.823 5.55271Z' />
      <path d='M3.4251 20.6694L11.5002 14.0625C12.3632 14.0625 13.0627 13.3629 13.0627 12.5C13.0627 11.6371 12.3632 10.9375 11.5002 10.9375C10.6373 10.9375 9.93775 11.6371 9.93775 12.5L3.33079 20.5751L3.29039 20.7098L3.4251 20.6694Z' />
    </svg>
  );
}

const products = [
  {
    name: 'MyEduzz Digital',
    title: 'Digital',
    subtitle: 'E-books, cursos online, planilhas...',
    icon: <CloudOutlined style={{ fontSize: 35 }} />,
    type: EProductType.DIGITAL,
    id: 'new-info-product-button',
  },
  {
    name: 'MyEduzz Assinaturas',
    title: 'Assinaturas',
    subtitle: 'Registre um produto e crie vários planos de assinatura.',
    type: EProductType.SUBSCRIPTION,
    icon: <DesignSubscriptionIcon />,
    id: 'new-subscription-button',
    betaModule: 'planos_assinatura',
    isNew: true,
  },
  {
    name: 'MyEduzz Físico',
    title: 'Físico',
    subtitle: 'Livros e apostilas',
    icon: <LocalShippingOutlined style={{ fontSize: 35 }} />,
    type: EProductType.PHYSICAL,
    id: 'new-physical-product-button',
  },
  {
    name: 'MyEduzz Serviço',
    description: 'Lá você vai encontrar tudo para criar e gerenciar seus serviços.',
    icon: <DesignServicesIcon />,
    title: 'Serviço Online',
    subtitle: 'Consultorias, Mentorias, Coaching...',
    type: EProductType.SERVICE,
    id: 'new-jobzz-product-button',
  },
  {
    name: 'Blinket',
    logo: '/img/blinket-symbol.svg',
    logoWidth: 35,
    description: 'Lá você vai encontrar tudo para criar e gerenciar seus eventos.',
    whyLink: 'https://ajuda.eduzz.com/?article=como-funciona-a-plataforma-blinket',
    whyLabel: 'a Blinket',
    color: '#ED1A62',
    redirect: 'https://app.blinket.com.br/event?utm_source=orbita&utm_medium=newproduct',
    title: 'Eventos',
    subtitle: 'Congressos, workshops, shows...',
    type: EProductType.TICKET,
    id: 'new-blinket-product-button',
  },
];

interface IProps extends DispatchProp<any> {}

interface IStates {
  productCard: typeof products;
}

class StepOne extends React.Component<IProps, IStates> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      productCard: products,
    };
  }

  componentDidMount() {
    let productCards = this.state.productCard;
    this.setState({ productCard: productCards });
  }

  onChooseType = async (selected: (typeof products)[0]) => {
    if (selected.type === EProductType.TICKET) {
      window.open(selected.redirect, '_blank');
      return;
    }
    try {
      await this.props.dispatch({ type: 'SET_VALUE_WIZARD_NP', value: selected.type });
      this.props.dispatch({ type: 'NEXT_STEP_WIZARD_NP' });
      const currentUrl = window.location.href;
      if (selected.type === EProductType.DIGITAL) window.history.replaceState(null, null, `${currentUrl}/digital`);
      if (selected.type === EProductType.PHYSICAL) window.history.replaceState(null, null, `${currentUrl}/physical`);
      if (selected.type === EProductType.SERVICE) window.history.replaceState(null, null, `${currentUrl}/service`);
      if (selected.type === EProductType.SUBSCRIPTION) window.history.replaceState(null, null, `${currentUrl}/subscription`);
    } catch (error) {}
  };

  render() {
    return (
      <div>
        <Grid container spacing={2} style={{ marginBottom: 16 }}>
          <Grid item xs={12}>
            <Breadcrumbs aria-label='breadcrumb'>
              <Link to='/producer/product/myproducts'>Meus Produtos</Link>
              <p>Tipo de produto</p>
            </Breadcrumbs>
          </Grid>
        </Grid>

        <TopPage title='Novo produto' />

        <Grid container spacing={2}>
          {products.map((product) => {
            if (product.betaModule && !eduzzAccountsService.verifyUserHasBetaModule(product.betaModule)) return null;
            return (
              <Grid item lg={3} md={6} xs={12} key={product.name}>
                <ButtonRedirect {...product} onClick={() => this.onChooseType(product)} />
              </Grid>
            );
          })}
        </Grid>
      </div>
    );
  }
}

export default connect()(StepOne);
